import React from "react";
import {ImageButton} from "../imageButton/ImageButton";
import {BlackTooltip} from "../tooltip/BlackTooltip";

interface ButtonProps {
    disabled: boolean
    handleClick: () => void
}

export const BroomButton: React.FC<ButtonProps> = ({
                                                       disabled,
                                                       handleClick
                                                   }) => {
    return <ImageButton
        disabled={disabled}
        onClick={handleClick}>
        <BlackTooltip title={"Reset filters"}>

            <svg fill="#000000" height="24px" width="24px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 79.707 79.707">
                <g>
                    <path d="M67.239,79.707l-8.41-28.273c-0.207-7.525-4.795-13.963-11.309-16.849V7.667C47.52,3.439,44.081,0,39.853,0
		c-4.227,0-7.666,3.439-7.666,7.667v26.918c-6.513,2.886-11.099,9.323-11.306,16.844l-8.413,28.275h54.771
		C67.239,79.704,67.239,79.707,67.239,79.707z M54.429,73.707l-3.431-12.806c-0.287-1.065-1.377-1.704-2.449-1.413
		c-1.067,0.284-1.7,1.381-1.414,2.448l3.152,11.771h-8.436v-12.29c0-1.104-0.896-2-2-2s-2,0.896-2,2v12.287h-7.435l3.153-11.771
		c0.286-1.065-0.347-2.164-1.414-2.449c-1.068-0.289-2.164,0.349-2.449,1.414l-3.431,12.806H20.51l5.579-18.75
		c0.004,0,0.008,0,0.012,0h27.5c0.004,0,0.008,0,0.015,0l5.575,18.75h-4.763L54.429,73.707L54.429,73.707z M38.187,7.667
		C38.187,6.748,38.935,6,39.853,6c0.919,0,1.667,0.748,1.667,1.667V33.04c-0.55-0.048-1.104-0.084-1.666-0.084
		s-1.117,0.036-1.667,0.084V7.667z M39.854,38.956c6.135,0,11.275,4.276,12.637,10H27.217C28.577,43.231,33.72,38.956,39.854,38.956
		z"/>
                </g>
            </svg>
        </BlackTooltip>
    </ImageButton>
}
